import { IconNames } from "@repo/core/components/core/Icon/types";
import { IBadgeType } from "./types";

export const OptionStyleMap: Record<
  IBadgeType,
  {
    action: "info" | "success" | "warning" | "error" | "muted";
    icon: IconNames;
    iconVariant?: "solid" | "regular";
    color: string;
  }
> = {
  [IBadgeType.success]: {
    action: "success",
    icon: "check-circle",
    color: "$primary600"
  },
  [IBadgeType.info]: {
    action: "info",
    icon: "verified",
    color: "$info600"
  },
  [IBadgeType.warning]: {
    action: "warning",
    icon: "clock",
    color: "$warning400"
  },
  [IBadgeType.error]: {
    action: "error",
    icon: "times-circle",
    color: "$error400"
  },
  [IBadgeType.analysis]: {
    action: "warning",
    icon: "hand-holding-dollar",
    color: "$warning300"
  },
  [IBadgeType.muted]: {
    action: "muted",
    icon: "circle-minus",
    color: "$secondary300"
  },
  [IBadgeType.draft]: {
    action: "muted",
    icon: "file-pen",
    iconVariant: "solid",
    color: "$secondary300"
  }
};
